import { css } from '@emotion/react';

import { Link, Typography } from '@zapier/design-system';
import { isInIframe, urls, useSize } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';
import { InlineActionButton } from '@zapier/auth-pages/src/components/global/InlineActionButton';
import { usePreviousUrl } from '@zapier/auth-pages/src/utils';
import { useRouter } from 'next/router';

const textStyle = css`
  ${Typography.Body1}
  text-align: center;
`;

const rootStyle = css`
  display: grid;
  gap: 20px;
  padding: 40px 0;
`;

function getPreviousUrl(currentUrl: string, previousUrl: string | undefined) {
  if (previousUrl && previousUrl !== currentUrl) {
    return previousUrl;
  }
  return urls.LOGIN_URL;
}

export function CookiesDisabledPage() {
  const size = useSize();
  const router = useRouter();
  const t = useTranslations('cookies-disabled');
  const previousUrl = getPreviousUrl(router.asPath, usePreviousUrl());

  function goBack() {
    router.back();
  }

  function TryAgainLink(chunks: React.ReactNode) {
    return <InlineActionButton onPress={goBack}>{chunks}</InlineActionButton>;
  }

  function NewTabLink(chunks: React.ReactNode) {
    return (
      <Link href={previousUrl} target="_blank">
        {chunks}
      </Link>
    );
  }

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={'Please enable cookies'}
      titlePosition={'right'}
    >
      <section css={rootStyle}>
        <p css={textStyle}>{t('description')}</p>
        <p css={textStyle}>{t.rich('clear-cookies', { link: TryAgainLink })}</p>
        {isInIframe() && (
          <p css={textStyle}>{t.rich('new-tab', { link: NewTabLink })}</p>
        )}
      </section>
    </AuthLayout>
  );
}
